// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  LINKS: {
    ADOBE_LAUNCH_URL:
      'https://assets.adobedtm.com/e8984c2d73c2/fa9895f94296/launch-a5b8d3533889-development.min.js',
    ADOBE_LAUNCH_MIGRATION_URL:
      'https://assets.adobedtm.com/e8984c2d73c2/fa9895f94296/launch-a5b8d3533889-development.min.js',
  },
  FLAGS: {
    OVERRIDE_ACCOUNT_LIST_NAMES: false,
    MOVE_PRODUCTS_CRD_TO_LN: false,
    OVERRIDE_BIN_PRODUCT: true,
  },
  CONSTANTS: {
    PRODUCT_854894_CREDITOBURSATIL: {
      backendProductTypeCode: "111",
      backendInstrumentTypeCode: "17"
    },
    BIN_PRODUCT_BY_PRODUCTTYPECODE: {
      '_18_55': '854894',
      '_18_54': '854895',
      '_113_163': '910015',
      '_18_50': '854876',
      '_18_43': '881355',
      '_18_44': '854857',
      '_117_225': '526489',
      '_117_228': '526445',
      '_117_224': '407559',
      '_18_51': '854877',
      '_18_40': '881049',
      '_18_42': '881054',
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
